import React from "react";
import ReactDOM from "react-dom";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

import API from "api/api";
import App from "./App";
import GlobalStyle from "./styles/globalStyle/index";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

(async () => {
    let hash = "";
    let user = {};

    // attempt at running local, more work to do
    // hash = 'be88cd8d7e2cfb268ff78d21b00340b423e32c194451c2f6881f6e20504c46e4'
    // user = { "ip": "198.181.8.5", "key": "2", "custom": { "impm": false, "agentIds": ["DZ400", "ED694"], "idp": "okta",
    //           "licensedStates": "AZ,CA,GA,HI,ID,NC,TX,NM", "org": "", "impmUser": "", "roles": ["advisor"], "groups":
    //           ["Everyone", "Annuities Site Group", "Funds Advisor Site Group", "My Account Site Group", "No MFA Group"],
    //           "type": "A", "agencyGroup": "PLSUIT", "agencyIds": ["10055", "10055"] } }

    try {
        hash = await API.getFeatureFlagHash();
        user = await API.getFeatureFlag();
    } catch (err) {
        console.error(err);
    }

    const LDProvider = await asyncWithLDProvider({
        clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
        user,
        options: {
            hash
        }
    });

    ReactDOM.render(
        <React.StrictMode>
            <LDProvider>
                <GlobalStyle />
                <App user={user} />
            </LDProvider>
        </React.StrictMode>,
        document.getElementById("root")
    );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
